module.exports = __webpack_public_path__ + "img/public_filetype_test_normal.5daa0236.svg";